
import { FC, MouseEventHandler } from "react";
import { ColumnType } from "src/Components/DataGrid";
import Text from "./Text";
import Date from "./Date";
import Enum from "./Enum";
import Relation from "./Relation";

export interface IFilterProps {
	/** Ид колонки ( для генерации ИД элемента ) */
	columnId: string;
	/** Тип колонки */
	columnType: ColumnType;

	/** Флаг открытия модалки */
	isShowModal: boolean;
	/** Управление открытием/закрытием модалки */
	setIsShowModal: ( isShow: boolean ) => void;
	
	/** Прокэшированное значение фильтра */
	value: any;
	/** Устанавливает кэш значения фильтра */
	setValue: ( newValue: any ) => void;

	/** Отмена ( закрытие модалки ) */
	cancelHandler: MouseEventHandler<HTMLButtonElement>;
	/** Применение кэша фильтра */
	applyValueHandler: MouseEventHandler<HTMLButtonElement>;
};

/** Возвращает компоненту фильтра по указанному типу колонки */
const getFilterControl = ( columnType: string ): FC<IFilterProps> => {
	// console.log( columnType );
	switch( columnType ) {

		case "relation": return Relation;
		
		case "boolean":
		case "bool":
		case "enum": return Enum;
		
		case "dateTime":
		case "date": return Date;
		
		case "string":
		default: return Text;
	}
};

export { Text, Date };
export default getFilterControl;
